module.exports = __webpack_public_path__ + "static/auto-331f32f29cebbc5c836c5c2a61a276ea.png";